export const TRIGGER_CREATE = 'TRIGGER_CREATE';
export const TRIGGER_EDIT = 'TRIGGER_EDIT';

export const REQUEST_USER_PENDING = 'REQUEST_USER_PENDING';
export const REQUEST_USER_SUCCESS = 'REQUEST_USER_SUCCESS';
export const REQUEST_USER_FAIL = 'REQUEST_USER_FAIL';

export const UPDATE_INFORMERS = 'UPDATE_INFORMERS';
export const UPDATE_COUNTERS = 'UPDATE_COUNTERS';
export const UPDATE_AGGREGATION_PARAMS = 'UPDATE_AGGREGATION_PARAMS';
export const UPDATE_AGGREGATION_PARAMS_2 = 'UPDATE_AGGREGATION_PARAMS_2';

export const triggerCreate = (value) => ({
  type: TRIGGER_CREATE,
  payload: value,
});

export const triggerEdit = (value) => ({
  type: TRIGGER_EDIT,
  payload: value,
});

export const updateInformers = (value) => ({
  type: UPDATE_INFORMERS,
  payload: value,
});

export const updateCounters = (value) => ({
  type: UPDATE_COUNTERS,
  payload: value
});

export const updateAggregationParams = (value) => ({
  type: UPDATE_AGGREGATION_PARAMS,
  payload: value
});

export const updateAggregationParams2 = (value) => ({
  type: UPDATE_AGGREGATION_PARAMS_2,
  payload: value
});

export const requestUser = () => ({ type: REQUEST_USER_PENDING });



// WEBPACK FOOTER //
// ./src/redux/actions.js